import { DoricPlugin } from "../DoricPlugin";
import { DoricSuperNode } from "../shader/DoricViewNode";
export class ShaderPlugin extends DoricPlugin {
    render(ret) {
        var _a;
        if (((_a = this.context.rootNode.viewId) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            const viewNode = this.context.targetViewNode(ret.id);
            viewNode === null || viewNode === void 0 ? void 0 : viewNode.blend(ret.props);
            viewNode === null || viewNode === void 0 ? void 0 : viewNode.onBlended();
        }
        else {
            this.context.rootNode.viewId = ret.id;
            this.context.rootNode.blend(ret.props);
            this.context.rootNode.onBlended();
        }
    }
    command(options) {
        let viewNode = undefined;
        for (let viewId of options.viewIds) {
            if (!viewNode) {
                viewNode = this.context.targetViewNode(viewId);
            }
            else {
                if (viewNode instanceof DoricSuperNode) {
                    viewNode = viewNode.getSubNodeById(viewId);
                }
            }
        }
        if (!viewNode) {
            return Promise.reject("Cannot find opposite view");
        }
        else {
            const target = viewNode;
            return new Promise((resolve, reject) => {
                try {
                    const method = Reflect.get(target, options.name);
                    if (!method) {
                        reject(`"Cannot find plugin method in class:${target},method:${options.name}"`);
                    }
                    resolve(Reflect.apply(method, target, [options.args]));
                }
                catch (err) {
                    reject(err);
                }
            });
        }
    }
}
//# sourceMappingURL=ShaderPlugin.js.map